import { render, staticRenderFns } from "./stockCheck.vue?vue&type=template&id=c80ffcae&scoped=true&"
import script from "./stockCheck.vue?vue&type=script&lang=js&"
export * from "./stockCheck.vue?vue&type=script&lang=js&"
import style0 from "./stockCheck.vue?vue&type=style&index=0&id=c80ffcae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80ffcae",
  null
  
)

export default component.exports